var option_webview_default = {
  "option": "RrZD2",
  "user_choice": "_9KwU5",
  "check": "hKimT",
  "image": "-wGG3",
  "input": "_4alvo",
  "title": "KeF9H",
  "centered": "e-Xeh",
  "with_result": "_4c-kX",
  "list": "r1gO1",
  "with_image": "JMF85",
  "progress": "YwpF-",
  "progress_value": "auoOo",
  "label": "yNCK0",
  "cta": "PZI4z",
  "adornment_icon": "jofbA",
  "remove": "i4Dev",
  "removeButton": "d95SI",
  "removeButtonIcon": "EBUGS",
  "overlay": "nZUFF",
  "shown": "oX-yo",
  "dark": "z9hI-",
  "spinner": "bkNQI",
  "spin": "T410M",
  "grid": "PBcDF"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
